<template>
  <div class="property_wrap">
    <div class="pro_top">视频设置</div>
    <div class="pro_con">
      <el-upload class=""
                 :action="uploadUrl"
                 :show-file-list="false"
                 :data="data_"
                 accept=".mp4"
                 :on-success="handleVideoSuccess"
                 :before-upload="beforeUploadVideo"
                 :on-progress="uploadVideoProcess">
        <video v-if="form.video && !videoFlag"
               :src="form.video"
               class="avatar video-avatar"
               controls="controls">您的浏览器不支持视频播放
        </video>
        <el-progress v-if="videoFlag == true"
                     type="circle"
                     :percentage="videoUploadPercent"
                     style="margin-top:30px;"></el-progress>
        <el-button class="video-btn"
                   slot="trigger"
                   size="small"
                   type="primary"
        v-if="!videoFlag">选取文件
        </el-button>
      </el-upload>
      <P v-if="isShowUploadVideo"
         class="prompInfo">请保证视频格式正确，且不超过50M</P>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js"
  export default {
    props: ["property"],
    data() {
      return {
        data_: {token: sessionStorage.getItem("token")},
        form: {
          label: '',
          video: '',
          poster:''
        },
        uploadUrl: api.uploadTokenVideo,//你要上传视频到你后台的地址
        videoFlag: false, //是否显示进度条
        videoUploadPercent: "", //进度条的进度，
        isShowUploadVideo: true, //显示上传按钮
        global:'',
        showVideoPath: ''
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.form.pic = URL.createObjectURL(file.raw);
        this.$message({
          message: '上传成功',
        });
      },

      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isLt2M;
      },
      progressFn(event, file, fileList) {
      },
      //上传前回调
      beforeUploadVideo(file) {
        const isLt20M = file.size / 1024 / 1024 < 50;
        if (['video/mp4'].indexOf(file.type) == -1) { //'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'
          this.$message.error('请上传正确的视频格式');
          return false;
        }
        if (!isLt20M) {
          this.$message.error('上传视频大小不能超过50MB哦!');
          return false;
        }
        this.isShowUploadVideo = false;
      },
      //进度条
      uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
      },

      //上传成功回调
      handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        if (res.code === 0) {
          this.form.video = res.path;
          this.form.poster = res.pic
          // this.videoForm.showVideoPath = res.data.uploadUrl;
        } else {
          this.$message.error('视频上传失败，请重新上传！');
        }
      },
    }
  };
</script>

